module.exports = __webpack_public_path__ + "media/0002.011c65d5.mp3";